import { InvestmentActivity } from "@common/enums/InvestmentActivity";
import { IAlertEventConfig } from "@common/models/IAlertEvent";

export enum EVENT_FREQUENCY {
  QUARTER = "QUARTER",
  ANNUAL = "ANNUAL"
}

export enum EVENT_TITLE_VALUE {
    QUARTER_DATA_REQUEST_AND_ENGINEERING_LETTERS_OUT_TO_PCS = "QUARTER_DATA_REQUEST_AND_ENGINEERING_LETTERS_OUT_TO_PCS",
    QUARTER_VALUATION_WORK_PERIOD = "QUARTER_VALUATION_WORK_PERIOD",
    QUARTER_SUBMIT_INITIAL_VALUATIONS_INTO_QUILT_AND_SUBMIT_VALUATION_COMMITTEE_SLIDES = "QUARTER_SUBMIT_INITIAL_VALUATIONS_INTO_QUILT_AND_SUBMIT_VALUATION_COMMITTEE_SLIDES",
    QUARTER_DRAFT_RETURNS = "QUARTER_DRAFT_RETURNS",
    QUARTER_VALUATION_COMMITTEE = "QUARTER_VALUATION_COMMITTEE",
    QUARTER_FINALIZE_VALUATION_SUBMIT_WRITE_UPS_AND_TEAR_SHEETS_ON_QUILT = "QUARTER_FINALIZE_VALUATION_SUBMIT_WRITE_UPS_AND_TEAR_SHEETS_ON_QUILT",
    QUARTER_ACCOUNTING_AND_IR_TEAM_COMPILE_FUND_FINANCIALS = "QUARTER_ACCOUNTING_AND_IR_TEAM_COMPILE_FUND_FINANCIALS",
    QUARTER_COMPLETION_DATES = "QUARTER_COMPLETION_DATES",
    QUARTER_COMPLETE_TEARSHEETS_ON_QUILT = "QUARTER_COMPLETE_TEARSHEETS_ON_QUILT",
    ANNUAL_DATA_REQUEST_AND_ENGINEERING_LETTERS_OUT_TO_PCS = "ANNUAL_DATA_REQUEST_AND_ENGINEERING_LETTERS_OUT_TO_PCS",
    ANNUAL_VALUATION_WORK_PERIOD = "ANNUAL_VALUATION_WORK_PERIOD",
    ANNUAL_SUBMIT_INITIAL_VALUATIONS_INTO_QUILT_AND_SUBMIT_VALUATION_COMMITTEE_SLIDES = "ANNUAL_SUBMIT_INITIAL_VALUATIONS_INTO_QUILT_AND_SUBMIT_VALUATION_COMMITTEE_SLIDES",
    ANNUAL_DRAFT_RETURNS = "ANNUAL_DRAFT_RETURNS",
    ANNUAL_VALUATION_COMMITTEE = "ANNUAL_VALUATION_COMMITTEE",
    ANNUAL_FINALIZE_VALUATION_SUBMIT_WRITE_UPS_SUPPORTING_MATERIALS_FOR_VALUATION_AND_TEAR_SHEETS_ON_QUILT = "ANNUAL_FINALIZE_VALUATION_SUBMIT_WRITE_UPS_SUPPORTING_MATERIALS_FOR_VALUATION_AND_TEAR_SHEETS_ON_QUILT",
    ANNUAL_ACCOUNTING_AND_IR_TEAM_COMPILE_FUND_FINANCIALS = "ANNUAL_ACCOUNTING_AND_IR_TEAM_COMPILE_FUND_FINANCIALS",
    ANNUAL_AUDITOR_REVIEW_AND_FINALIZATION = "ANNUAL_AUDITOR_REVIEW_AND_FINALIZATION",
    ANNUAL_COMPLETE_TEARSHEETS_ON_QUILT = "ANNUAL_COMPLETE_TEARSHEETS_ON_QUILT",
    BOARD_MATERIALS_SUBMISSION = "BOARD_MATERIALS_SUBMISSION"
}

type ActivityAlertConfig = {
  trackOverlap: boolean;
  frequency?: (qtr: string) => EVENT_FREQUENCY;
  taskConfig?: IAlertEventConfig;
};

type AddTaskConfig = {
  canTrackCompletion: boolean;
  showStatus: boolean;
};

const quarterOrAnnual = (qtr: string): EVENT_FREQUENCY => {
  const [, nStr] = qtr.split('-')[1].split('');
  return +nStr < 4 ? EVENT_FREQUENCY.QUARTER : EVENT_FREQUENCY.ANNUAL;
};

const DEFAULT_TASK_CONFIG: IAlertEventConfig = {
  showActivityTask: true,
  showValuationTask: false,
  showWriteUpTask: false,
  showTearsheetTask: false,
  showBoardBookApprovalTask: false,
  showFinancialApprovalTask: false,
  showStatusTask: false
}

export const ACTIVITY_ALERT_CONFIG: Partial<Record<InvestmentActivity, ActivityAlertConfig>> = {
  [InvestmentActivity.Valuation]: {
    trackOverlap: true,
    frequency: quarterOrAnnual,
    taskConfig: {
      showActivityTask: true,
      showValuationTask: true,
      showWriteUpTask: false,
      showTearsheetTask: false,
      showBoardBookApprovalTask: false,
      showFinancialApprovalTask: false,
      showStatusTask: true
    }
  },
  [InvestmentActivity.Tearsheets]: {
    trackOverlap: true,
    frequency: quarterOrAnnual,
    taskConfig: {
      showActivityTask: true,
      showValuationTask: false,
      showWriteUpTask: false,
      showTearsheetTask: true,
      showBoardBookApprovalTask: false,
      showFinancialApprovalTask: false,
      showStatusTask: true
    }
  },
  [InvestmentActivity.Documents]: {
    trackOverlap: false,
    taskConfig: {
      showActivityTask: false,
      showValuationTask: false,
      showWriteUpTask: false,
      showTearsheetTask: false,
      showBoardBookApprovalTask: true,
      showFinancialApprovalTask: true,
      showStatusTask: false
    }
  },
  [InvestmentActivity.Review]: {
    trackOverlap: false,
    taskConfig: DEFAULT_TASK_CONFIG
  },
  [InvestmentActivity.Meeting]: {
    trackOverlap: false,
    taskConfig: DEFAULT_TASK_CONFIG
  },
  [InvestmentActivity.Others]: {
    trackOverlap: false,
    taskConfig: DEFAULT_TASK_CONFIG
  },
};

export const ADD_TASK_CONFIG: Partial<Record<InvestmentActivity, AddTaskConfig>> = {
  [InvestmentActivity.Valuation]: {
    canTrackCompletion: false,
    showStatus: true,
  },
  [InvestmentActivity.Tearsheets]: {
    canTrackCompletion: false,
    showStatus: true,
  },
  [InvestmentActivity.Documents]: {
    canTrackCompletion: false,
    showStatus: true,
  },
  [InvestmentActivity.Review]: {
    canTrackCompletion: false,
    showStatus: true,
  },
  [InvestmentActivity.Meeting]: {
    canTrackCompletion: true,
    showStatus: false,
  },
  [InvestmentActivity.Others]: {
    canTrackCompletion: false,
    showStatus: true,
  },
};